package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.checked_ingredients_list.CheckedIngredient
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.SearchBarWithAddEditCloseIcon

@Composable
fun AlergensTable(
    windowSizeMode: WindowSizeModeEnum,
    onAddAlergenClick:()->Unit,
    onSearchValueChange: (String) -> Unit,
    ingredients: List<Ingredients>?,
    checkedIngredients: List<CheckedIngredient?>?,
    updateAllergenData: (Boolean, String) -> Unit
) {
    Column(
        modifier = Modifier
            .width(Dimen.allergensTableWidth)
            .thenIf(
                windowSizeMode!=WindowSizeModeEnum.Desktop,
                Modifier.fillMaxWidth()
            )
            .showContentInOnePage()
            .fillMaxHeight()
    )
    {
        SearchBarWithAddEditCloseIcon(
            showEdit = false,
            showDelete = false,
            onSearchInfo = {
                onSearchValueChange(it)
            },
            onAddClick = {
                onAddAlergenClick()
            },
        )


        val tableData = ingredients?.map { ingredient ->
            val isChecked = checkedIngredients?.any {
                it?.ingredientId == ingredient.id && it?.contains == true
            } ?: false

            mapOf(
                "id" to ingredient.id,
                "number" to ingredient.code,
                "name" to ingredient.name,
                "isChecked" to isChecked,
                "model" to ingredient
            )
        }

        val columns = listOf(
            TableColumn(
                header = Strings.current().number,
                key = "number",
                isSortable = true,
            ),
            TableColumn(
                header = Strings.current().contain,
                key = "isChecked",
                isSortable = false,
                width = Dimen.headerSmallWidth.value.toInt(),
                customContent = { row ->
                    {
                        CheckboxComponent(
                            modifier = Modifier.margin(left = Dimen.largePadding) ,
                            checkStatus = row["isChecked"] as Boolean,
                            title = "",
                            onChecked = {
                                updateAllergenData(true, row["id"]?.toString() ?: "")
                            },
                            onUnChecked = {
                                updateAllergenData(false, row["id"]?.toString() ?: "")
                            }
                        )
                    }
                }
            ),
            TableColumn(
                header = Strings.current().name,
                key = "name",
                isSortable = true,
            )
        )

        CustomTable(
            modifier = Modifier
                .weight(1f)
                .showContentInOnePage() ,
            columns = columns,
            data = tableData,
            isCustom = true,
            width =if (windowSizeMode==WindowSizeModeEnum.Desktop)
                Dimen.allergensTableWidth else null,
            showRefreshButton = true,
            onRefresh = { },
        )
    }
}